import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import { useNavigate } from "react-router-dom";
import ViewData from "./ViewData";
import UserInfo from "@utils/UserInfo";
import PrepareDataTable from "./PrepareDataTable";
import { QuoteListContainer } from "./QuoteList.styled";
import "./QuoteList.scss";
/**
 * Quote List,
 * Path - /qotes
 * @see See [Enquiry Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2979135489/Site+-+Quotes)
 * @component
 */
const QuoteList = (props) => {
  const {
    t,
    entityId,
    entityType,
    setIsRefeshSiteData,
    page,
    columnList,
    dependancies,
    jobsiteNeedKickoff,
    sitePlatformCountryCountryId,
  } = props;

  const countryId = UserInfo.countryId();
  const [isRefreshList, setIsRefreshList] = useState(false);
  const history = useNavigate();
  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  const createQuote = () => {
    history(`/site/view/${entityId}/quote-create`);
  };

  return (
    <QuoteListContainer className="quote-listing">
      {page === "list" && countryId && (
        <PrepareDataTable
          isRefreshList={isRefreshList}
          updateRefeshStatus={updateRefeshStatus}
          columnList={columnList}
          countryId={countryId}
          dependancies={dependancies}
          entityId={entityId}
        />
      )}
      {page === "view" && countryId && (
        <ViewData
          isRefreshList={isRefreshList}
          updateRefeshStatus={updateRefeshStatus}
          entityId={entityId}
          entityType={entityType}
          createQuote={createQuote}
          setIsRefeshSiteData={setIsRefeshSiteData}
          countryId={sitePlatformCountryCountryId}
          dependancies={dependancies}
          jobsiteNeedKickoff={jobsiteNeedKickoff}
        />
      )}
    </QuoteListContainer>
  );
};

QuoteList.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
  list: PropTypes.string,
  columnList: PropTypes.arrayOf(PropTypes.string),
  platformCountryId: PropTypes.number,
  dependancies: PropTypes.string,
  jobsiteNeedKickoff: PropTypes.number,
};

QuoteList.defaultProps = {
  page: "view",
  list: "all",
  columnList: [],
  platformCountryId: null,
  dependancies: "",
  jobsiteNeedKickoff: 0,
};

export default withTranslation()(QuoteList);
